import siteUrls from '@/helpers/site_urls'

export default {
  year: new Date().getFullYear().toString(),
  siteUrls
}



// WEBPACK FOOTER //
// ./frontend/src/mixins/footer.js